<template>
  <div class="border-t border-gray-300 pt-3 pb-3">
    <div
      class="flex pb-0.5"
      :class="attribute.attributes ? 'cursor-pointer' : ''"
      @click="showSub = !showSub"
    >
      <div class="text-gray-900 tech font-bold tracking-wide">
        {{ attribute.name }}
      </div>
      <div class="text-gray-600 pl-2 text-xs tech" style="padding-top: 4px">
        {{
          attribute.required ? attribute.type : attribute.type + ", optional"
        }}
      </div>
      <div
        class="flex-1 text-right text-sm text-primary"
        v-if="attribute.attributes"
      >
        {{ showSub ? "Hide" : "Show" }} children
      </div>
    </div>
    <div
      class="section-desc text-gray-700 mt-0.5 text-sm"
      v-html="attribute.desc"
    ></div>
    <div v-if="attribute.attributes && showSub" class="pl-10 pt-4">
      <div
        v-for="sub in attribute.attributes"
        v-bind:key="sub.name + attribute.name"
      >
        <CodeAttribute :attribute="sub" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeAttribute",
  data: () => {
    return {
      showSub: false,
    };
  },
  props: ["attribute"],
  mounted() {},
  computed: {},
  methods: {},
  components: {},
};
</script>
